import { ThemeProvider } from '@material-ui/core/styles';
import 'array-flat-polyfill';
import { FunctionalComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { Provider } from 'react-redux';

import { createNewTab, getTranslation } from '../shared/chromeApi';
import ErrorBoundary from './ErrorBoundary';

import store from './store';

import Ui from './features/ui';
import User from './features/user';
// import Surveys from './features/surveys';

import PageContent from './PageContent';
import ModalRoot from './shared/Modal';
import theme from './theme';

// Handling Safari back button
if (typeof window !== 'undefined') {
  window.addEventListener(
    'pageshow',
    (evt) => {
      if (evt.persisted) {
        setTimeout(() => {
          window.location.reload();
        }, 10);
      }
    },
    false
  );
}

const App: FunctionalComponent = () => {
  useEffect(() => {
    document.title = getTranslation('new_tab_title');
  }, []);

  useEffect(() => {
    const listener = (evt: MouseEvent): void => {
      const target = evt.target as HTMLAnchorElement;

      if (target.tagName === 'A' && target.href.match('chrome://')) {
        evt.preventDefault();
        createNewTab(target.href);
      }
    };
    document.addEventListener('click', listener);
    return (): void => {
      document.removeEventListener('click', listener);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Ui>
          <User />
          <PageContent />

          {/*{process.env.APP_TYPE !== 'schools' && <Surveys />}*/}

          <ErrorBoundary message={null} name="modal">
            <ModalRoot />
          </ErrorBoundary>
        </Ui>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
